export const STUDENT_MINIMUM_AGE = 16;
export const STUDENT_MAXIMUM_AGE = 70;
import { djs } from '@duke-hq/djs';

export function isUnderMinimumAge(dateOfBirth: Date | undefined | null): boolean {
  if (!(dateOfBirth instanceof Date)) {
    return false;
  }

  const dob = djs(dateOfBirth);
  const age = djs().diff(dob, 'years');
  return age < STUDENT_MINIMUM_AGE;
}

/** The earliest and latest birth dates an enrolling student can have today, as `YYYY-MM-DD`. */
export function studentBirthDateRange(): { earliest: string; latest: string } {
  const today = djs();
  return {
    earliest: today.subtract(STUDENT_MAXIMUM_AGE, 'year').format('YYYY-MM-DD'),
    latest: today.subtract(STUDENT_MINIMUM_AGE, 'year').format('YYYY-MM-DD'),
  };
}
